import { useEffect, useState } from "react";

export default function (id, prefix?: string) {
  const [finalId, setId] = useState(id);
  useEffect(() => {
    setId(
      `${prefix}${(Math.random() * 1000)
        .toString()
        .replace(".", "")
        .slice(0, 20)}`
    );
  }, []);
  return finalId;
}
